
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.868 17.5a1 1 0 00.866 1.5h18.531a1 1 0 00.866-1.5L11.865 1.494a1 1 0 00-1.731 0L.868 17.5zM12 15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.5-3a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h1z","fill":"#EB0000"}})])
          )
        }
      }
    